
export const debounce = (fn, timeout) => {
  var timer;
  return function(event){
    if(timer) clearTimeout(timer);
    timer = setTimeout(fn,timeout,event);
  };
}
